import React from "react"
import { Link } from "gatsby"
import type { RelatedLink } from "../../data/types"

type RelatedLinksProps = {
  links: RelatedLink[]
  heading?: string
}

export const RelatedLinks = ({ links, heading }: RelatedLinksProps) => {
  if (!links || links.length === 0) return null
  return (
    <section className="text-gray-700 body-font bg-purple-50">
      <div className="container mx-auto px-5 py-10">
        <div className="max-w-3xl">
          <h2 className="title-font text-2xl font-medium text-gray-900 mb-5">
            {heading || "Continue lendo"}
          </h2>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {links.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="block bg-white rounded px-4 py-3 hover:bg-purple-100 transition-colors"
                >
                  <span className="text-purple-700 font-medium">
                    {link.label}
                  </span>
                  <span className="text-purple-400 ml-2">→</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
